<template lang="pug">

transition(
  appear
)
  .icon-share
    svg(width="100%" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg")
      circle(cx="13.5" cy="13.5" r="12.5" stroke="#fff" stroke-width="2")
      path(d="M6.19995 15.4001C6.19995 17.6001 8.09995 19.6001 11.3 20.7001C11.4 20.7001 11.5 20.7001 11.5 20.7001C11.8 20.7001 12.1 20.5001 12.1 20.2001C12.2 19.9001 12 19.6001 11.7 19.4001C10.3 18.8001 9.59995 17.9001 9.59995 17.0001C9.59995 15.5001 11.8 14.2001 14.7 13.9001V15.2001C14.7 16.0001 15.6 16.3001 16.1 15.9001L20.3 12.2001C20.5 12.0001 20.6 11.8001 20.6 11.5001C20.6 11.2001 20.5 10.9001 20.2 10.8001L16 7.10007C15.3 6.60007 14.5 7.10007 14.5 7.80007V9.10007C9.79995 9.80007 6.19995 12.4001 6.19995 15.4001Z" fill="white")



</template>

<script>
export default {
  name: 'icon-share',
  components: {},
  data() {
    return {}
  },
  props: {},
  computed: {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
  watch: {},
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.icon-share
  width: 100%
  //overflow: hidden









</style>
